import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import { formatDateCustom } from './format-date-custom.js';
import isSameYear from 'date-fns/isSameYear';

/**
 * Formats `startDate` and `endDate` as a range.
 *
 * Use this for UIs where displaying a date range is needed, such as expected delivery date range.
 *
 * If `startDate` and `endDate` are in the same year, `startDate` year is hidden.
 * - e.g. Same year => "01/01 - 01/02/2021"
 * - e.g. Different years => "12/31/2020 - 01/01/2021"
 *
 * Defaults:
 * - `format` = "short"
 * - `includeDayOfWeek` = "false"
 * - `includeTime` = "false"
 * - `ianaTimeZone` = "undefined"
 */
function formatDateRange(startDate, endDate, options) {
    let convertedStartDate = new Date(startDate);
    let convertedEndDate = new Date(endDate);
    const ianaTimeZone = options === null || options === void 0 ? void 0 : options.ianaTimeZone;
    // if setting the time zone, convert the time to the zoned time
    if (ianaTimeZone) {
        convertedStartDate = utcToZonedTime(convertedStartDate, ianaTimeZone);
        convertedEndDate = utcToZonedTime(convertedEndDate, ianaTimeZone);
    }
    const formatedStartDate = isSameYear(convertedStartDate, convertedEndDate)
        ? formatDateCustom(startDate, Object.assign(Object.assign({}, options), { includeYear: false }))
        : formatDateCustom(startDate, Object.assign(Object.assign({}, options), { includeYear: true }));
    const formatedEndDate = formatDateCustom(endDate, Object.assign(Object.assign({}, options), { includeYear: true }));
    return `${formatedStartDate} - ${formatedEndDate}`;
}

export { formatDateRange };
//# sourceMappingURL=format-date-range.js.map
